<template>
  <div class="colRefForm">
    <div class="intro">{{Period_Grade}}</div>
    <div class="txtform">
      <p>Invitamos a todos los Estudiantes Iberoamericanos de pregrado y posgrado de las modalidades presencial, virtual y distancia que cumplan con los siguientes requisitos de grado:</p>
      <ul class="doc-nav-item-ul-vi">
        <li>Haber cursado y aprobado la totalidad de créditos del plan de estudios del programa correspondiente.</li>
        <li>Haber cumplido con los requisitos de la opción de grado en cualquiera de las modalidades previstas por la Institución.</li>
        <li>Haber presentado el Examen de Calidad de la Educación Superior SABER PRO (Solo para PREGRADO) SABER T&T (Solo para TECNOLOGO).</li>
        <li>Estar a paz y salvo por todo concepto con la Iberoamericana. </li>
        <li>No encontrarse vinculado a un proceso disciplinario, ni en cumplimiento de una sanción, para la obtención de su título tecnólogo, profesional o especialista. </li>
      </ul>
      <p>Recuerde que el formulario se encontrará habilitado hasta el día <strong>{{End_Insc}}</strong></p>
    </div>
    <div class="docs">
      Documentos requeridos pregrado
    </div>
    <div class="docform">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6">
          <div class="doc-nav-item">
            <div class="icon text-left">
              <i class="fa fa-id-card-o mr-2 text-danger"></i>
              <ul class="doc-nav-item-ul mt-2">
                <li>Copia de Documento de Identidad.</li>
                <li>Resultados o certificado de asistencia de SABER PRO o SABER T&T según corresponda.</li>
                <li>Copia de Acta o diploma de Bachiller</li>
                <li>Resultados SABER 11</li>
              </ul>
            </div>
            <div class="doc-nav-item-txt"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="docs mt-4">
      Documentos requeridos posgrado
    </div>
    <div class="docform">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6">
          <div class="doc-nav-item">
            <div class="icon text-left">
              <i class="fa fa-id-card-o mr-2 text-danger"></i>
              <ul class="doc-nav-item-ul mt-2">
                <li>Copia de Documento de Identidad</li>
                <li>Copia de Acta o diploma de Pregrado</li>
              </ul>
            </div>
            <div class="doc-nav-item-txt"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="txtform">
      <p>

      </p>
    </div>
  </div>
</template>

<script>
import IberoHelpers from '@/store/helpers.js'

export default {
  name: 'colRefForm',

  data () {
    return {
      Period_Grade: '',
      End_Insc: '',
    }
  },
  mounted () {
    var ListGrades = IberoHelpers.getGradeActive(this.$store, '', 0)
    this.renderComponent1 = false
    ListGrades.then(Response => {
      if ((Response.data === undefined) || (Response.data === '')) {
        document.getElementById('refNoData').classList.remove('noShow')
      } else {
        document.getElementById('FormGrades2').classList.remove('noShow')
        this.Period_Grade = Response.data[0].Information
        this.End_Insc = Response.data[0].dat_EndInscription
      }
    })
  },
}

</script>

<style scoped>
.colRefForm {
  color: #000;
  text-align: center;
}

.scrimgform {
  margin-bottom: 50px;
}

.imgform {
  width: 200px;
  height: 200px;
}

.colRefForm .intro {
  color: #a2273c;
  font-size: 32px;
  font-weight: 500;
  margin-bottom: 30px;
}

.colRefForm .docs {
  color: #a2273c;
  font-size: 22px;
  font-weight: 700;
  margin-top: 25px;
  margin-bottom: 15px;
}

.colRefForm .txtform p {
  font-size: 15px;
  margin-bottom: 12px;
  box-sizing: border-box;
  display: block;
  line-height: 24px;
  font-weight: 400;
  text-align: justify;
}

.txtform {
  text-align: left;
}

.doc-nav-item {
  background-color: #ffffff;
  font-size: 13px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 20px 24px;
}

.doc-nav-item-ul {
  text-align: left;
  font-size: 14px;
  padding: 0px 0px 0px 20px;
  color: #334155;
  list-style-type: square;
  margin-bottom: 0;
}

.doc-nav-item-ul-vi {
  text-align: left;
  font-size: 14px;
  padding: 0px 0px 0px 20px;
  color: #334155;
  list-style-type: square;
  margin-bottom: 15px;
}

.docform {
  color: #000;
  margin-bottom: 20px;
}

.fa-id-card-o:before {
  content: "\f2c3";
}
</style>
